export const crossword_style = {
    columnBreakpoint: '9999px',
    gridBackground: 'black',
    cellBackground: 'white',
    cellBorder: 'black',
    textColor: 'black',
    numberColor: 'black',
    focusBackground: '#FF6600',
    highlightBackground: '#FFD1B2'
}

export const modal_style = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.75)'
    },
    content: {
        position: 'absolute',
        top: '40px',
        left: '40px',
        right: '40px',
        bottom: '40px',
        border: '1px solid #ccc',
        background: '#fff',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '4px',
        outline: 'none',
        padding: '20px'
    }
}

export const pauseModalStyle = {
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 100
    },
    content: {
        position: 'absolute',
        top: '30%',
        left: '25%',
        right: '25%',
        bottom: '40%',
        border: '1px solid #ccc',
        background: '#fff',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '4px',
        outline: 'none',
        padding: '20px'
    }
}